import Modal from '@/common/components/Modal/Modal';

export default Modal;
